// src/components/Icons.tsx
// Libreria icone SVG realistiche - ZERO dipendenze - Sfondo trasparente

interface IconProps {
  className?: string;
  color?: string;
}

// Icona Barca - REALISTICA
export const ShipIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M32 8L8 20v24l24 12 24-12V20L32 8z" 
      fill={color} 
      fillOpacity="0.15"
      stroke={color} 
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path 
      d="M16 28h32v12H16z" 
      fill={color} 
      fillOpacity="0.3"
    />
    <rect x="24" y="18" width="16" height="10" rx="2" fill={color} fillOpacity="0.5"/>
    <path d="M8 44l24 8 24-8" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icona Posizione - REALISTICA
export const MapPinIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M32 6C20.95 6 12 14.95 12 26c0 15 20 32 20 32s20-17 20-32c0-11.05-8.95-20-20-20z" 
      fill={color} 
      fillOpacity="0.15"
      stroke={color} 
      strokeWidth="2"
    />
    <circle cx="32" cy="26" r="8" fill={color} fillOpacity="0.5" stroke={color} strokeWidth="2"/>
    <circle cx="32" cy="26" r="4" fill={color}/>
  </svg>
);

// Icona Soldi - REALISTICA
export const DollarIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path
      d="M20 32h24M24 24c-4.4 0-8 3.6-8 8s3.6 8 8 8M40 24c4.4 0 8 3.6 8 8s-3.6 8-8 8"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path d="M20 32h24" stroke={color} strokeWidth="2" strokeDasharray="4 4" opacity="0.3"/>
  </svg>
);

// Icona Check - REALISTICA
export const CheckIcon = ({ className = "w-10 h-10", color = "#22c55e" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill={color} fillOpacity="0.15" stroke={color} strokeWidth="2"/>
    <path d="M20 32l8 8 16-16" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Icona X - REALISTICA
export const XIcon = ({ className = "w-10 h-10", color = "#ef4444" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill={color} fillOpacity="0.15" stroke={color} strokeWidth="2"/>
    <path d="M20 20l24 24M44 20l-24 24" stroke={color} strokeWidth="4" strokeLinecap="round"/>
  </svg>
);

// Icona Upload - REALISTICA
export const UploadIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="8" y="12" width="48" height="40" rx="4" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M32 20v20M24 32l8-8 8 8" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 48h32" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icona Download - REALISTICA
export const DownloadIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="8" y="12" width="48" height="40" rx="4" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M32 32v20M24 44l8 8 8-8" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 20h32" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icona CSV/File - REALISTICA
export const FileSpreadsheetIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path d="M12 4h28l12 12v44H12V4z" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M40 4v12h12" stroke={color} strokeWidth="2"/>
    <path d="M18 24h28M18 32h20M18 40h24" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icona Filtro - REALISTICA
export const FilterIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M8 12l48 36M20 40l-8 12M44 28l-8 12" 
      stroke={color} 
      strokeWidth="3" 
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="16" cy="16" r="3" fill={color} fillOpacity="0.5"/>
    <circle cx="32" cy="24" r="3" fill={color} fillOpacity="0.5"/>
    <circle cx="48" cy="32" r="3" fill={color} fillOpacity="0.5"/>
  </svg>
);

// Icona Ricerca - REALISTICA
export const SearchIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="28" cy="28" r="16" stroke={color} strokeWidth="3" fill="none"/>
    <path d="M44 44l12 12" stroke={color} strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

// Icona Chat - REALISTICA
export const ChatIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M8 12c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v28c0 4.4-3.6 8-8 8H24l-12 12V12z" 
      fill={color} 
      fillOpacity="0.1"
      stroke={color} 
      strokeWidth="2"
    />
    <path d="M16 28h24M16 36h16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icona Dashboard - REALISTICA
export const DashboardIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="6" y="6" width="24" height="24" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <rect x="34" y="6" width="24" height="12" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <rect x="34" y="22" width="24" height="8" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <rect x="6" y="34" width="24" height="8" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <rect x="34" y="34" width="24" height="24" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
  </svg>
);

// Icona Statistiche - REALISTICA
export const TrendingIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path d="M8 56h48M8 44h48M8 32h48M8 20h48M8 8h48" stroke={color} strokeWidth="1" opacity="0.2"/>
    <path 
      d="M8 48l12-8 12 4 12-12 12 4" 
      stroke={color} 
      strokeWidth="3" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="20" cy="40" r="3" fill={color}/>
    <circle cx="32" cy="44" r="3" fill={color}/>
    <circle cx="44" cy="32" r="3" fill={color}/>
    <circle cx="56" cy="36" r="3" fill={color}/>
  </svg>
);

// Icona Calendario - REALISTICA
export const CalendarIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="6" y="10" width="52" height="44" rx="4" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M6 18h52v8H6z" fill={color} fillOpacity="0.3"/>
    <circle cx="20" cy="36" r="3" fill={color} fillOpacity="0.5"/>
    <circle cx="32" cy="36" r="3" fill={color}/>
    <circle cx="44" cy="36" r="3" fill={color} fillOpacity="0.5"/>
    <circle cx="20" cy="46" r="3" fill={color} fillOpacity="0.5"/>
    <circle cx="32" cy="46" r="3" fill={color} fillOpacity="0.5"/>
  </svg>
);

// Icona Orologio - REALISTICA
export const ClockIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="26" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M32 16v16l12 8" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    <circle cx="32" cy="32" r="4" fill={color}/>
  </svg>
);

// Icona Freccia destra - REALISTICA
export const ArrowRightIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M24 20l16 12-16 12" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Icona Occhio - REALISTICA
export const EyeIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M8 32s8-20 24-20 24 20 24 20-8 20-24 20-24-20-24-20z" 
      stroke={color} 
      strokeWidth="2" 
      fill="none"
    />
    <circle cx="32" cy="32" r="10" fill={color} fillOpacity="0.3" stroke={color} strokeWidth="2"/>
    <circle cx="32" cy="32" r="4" fill={color}/>
  </svg>
);

// Icona Stella - REALISTICA
export const StarIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M32 8l7.5 15.2L56 25.8l-12 11.7 2.8 16.5L32 44.8 17.2 54l2.8-16.5-12-11.7L24.5 23.2 32 8z" 
      fill={color} 
      fillOpacity="0.2"
      stroke={color} 
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

// Icona Stella piena
export const StarFilledIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M32 8l7.5 15.2L56 25.8l-12 11.7 2.8 16.5L32 44.8 17.2 54l2.8-16.5-12-11.7L24.5 23.2 32 8z" 
      fill={color}
    />
  </svg>
);

// Icona Notifica - REALISTICA
export const BellIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M32 8c-11 0-20 9-20 20v12l-4 8h48l-4-8V28c0-11-9-20-20-20z" 
      fill={color} 
      fillOpacity="0.1"
      stroke={color} 
      strokeWidth="2"
    />
    <path d="M24 56c0 4 3.6 8 8 8s8-4 8-8" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="32" cy="18" r="3" fill={color}/>
  </svg>
);

// Icona Email - REALISTICA
export const MailIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="6" y="14" width="52" height="36" rx="4" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M6 18l26 18 26-18" stroke={color} strokeWidth="2"/>
  </svg>
);

// Icona Credit Card - REALISTICA
export const CreditCardIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="4" y="14" width="56" height="36" rx="4" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M4 26h56" stroke={color} strokeWidth="2"/>
    <rect x="8" y="32" width="16" height="10" rx="2" fill={color} fillOpacity="0.3"/>
  </svg>
);

// Icona Info - REALISTICA
export const InfoIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M32 20v-4M32 44v-4" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    <circle cx="32" cy="32" r="2" fill={color}/>
  </svg>
);

// Icona Building/Concessionario - REALISTICA
export const BuildingIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path d="M8 56V16l24-12 24 12v40H8z" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <rect x="14" y="28" width="10" height="10" fill={color} fillOpacity="0.3"/>
    <rect x="27" y="28" width="10" height="10" fill={color} fillOpacity="0.3"/>
    <rect x="40" y="28" width="10" height="10" fill={color} fillOpacity="0.3"/>
    <rect x="14" y="42" width="10" height="10" fill={color} fillOpacity="0.3"/>
    <rect x="27" y="42" width="10" height="10" fill={color} fillOpacity="0.3"/>
    <rect x="40" y="42" width="10" height="10" fill={color} fillOpacity="0.3"/>
    <path d="M32 4v12" stroke={color} strokeWidth="2"/>
  </svg>
);

// Icona User - REALISTICA
export const UserIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="20" r="12" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <path d="M12 56c0-11 9-20 20-20s20 9 20 20" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

// Icona Image - REALISTICA
export const ImageIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="6" y="10" width="52" height="44" rx="4" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <circle cx="22" cy="24" r="6" fill={color} fillOpacity="0.3"/>
    <path d="M6 44l16-14 12 8 12-16 12 10" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Icona Infinity - REALISTICA
export const InfinityIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M8 32c0-8 6-12 12-12s12 4 12 12-6 12-12 12-12-4-12-12zm12 0c0-8 6-12 12-12s12 4 12 12-6 12-12 12-12-4-12-12z" 
      fill={color} 
      fillOpacity="0.2"
      stroke={color} 
      strokeWidth="2"
    />
  </svg>
);

// Icona Plus - REALISTICA
export const PlusIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M32 20v24M20 32h24" stroke={color} strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

// Icona Minus - REALISTICA
export const MinusIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="28" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M20 32h24" stroke={color} strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

// Icona Navigation/GPS - REALISTICA
export const NavigationIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M32 4l8 28-8 8-8-8 8-28z" 
      fill={color} 
      fillOpacity="0.2"
      stroke={color} 
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="32" cy="32" r="4" fill={color}/>
  </svg>
);

// Icona Alert/Warning - REALISTICA
export const AlertIcon = ({ className = "w-10 h-10", color = "#f59e0b" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path d="M32 4L4 56h56L32 4z" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
    <path d="M32 24v12M32 44v-4" stroke={color} strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

// Icona Truck - REALISTICA
export const TruckIcon = ({ className = "w-12 h-12", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="4" y="20" width="40" height="24" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <path d="M44 24h8v20h-8M12 44v8M28 44v8" stroke={color} strokeWidth="2"/>
    <rect x="8" y="26" width="12" height="8" rx="1" fill={color} fillOpacity="0.3"/>
  </svg>
);

// Icona File/Document - REALISTICA
export const FileIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path d="M12 4h28l12 12v44H12V4z" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M40 4v12h12" stroke={color} strokeWidth="2"/>
  </svg>
);

// Icona Heart - REALISTICA
export const HeartIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M32 12l-4-4C12 4 4 12 4 20c0 12 28 28 28 28s28-16 28-28c0-8-8-16-24-16-8 0-12 4-12 4" 
      fill={color} 
      fillOpacity="0.2"
      stroke={color} 
      strokeWidth="2"
    />
  </svg>
);

// Icona Settings - REALISTICA
export const SettingsIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="12" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="32" cy="32" r="24" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="32" cy="8" r="3" fill={color}/>
    <circle cx="32" cy="56" r="3" fill={color}/>
    <circle cx="8" cy="32" r="3" fill={color}/>
    <circle cx="56" cy="32" r="3" fill={color}/>
  </svg>
);

// Icona Phone - REALISTICA
export const PhoneIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M16 4h32a4 4 0 0 1 4 4v40a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4z" 
      fill={color} 
      fillOpacity="0.1" 
      stroke={color} 
      strokeWidth="2"
    />
    <path d="M20 8v8a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V8" stroke={color} strokeWidth="2"/>
    <path d="M24 24l4 4 8-8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

// Icona Logout - REALISTICA
export const LogoutIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M12 16h28c4 0 8 4 8 8v32H12V24c0-4 4-8 8-8z" 
      fill={color} 
      fillOpacity="0.1" 
      stroke={color} 
      strokeWidth="2"
    />
    <path d="M20 32l-8-8v6H4v4h8v6z" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

// Icona Login - REALISTICA
export const LoginIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path 
      d="M12 16h28c4 0 8 4 8 8v32H12V24c0-4 4-8 8-8z" 
      fill={color} 
      fillOpacity="0.1" 
      stroke={color} 
      strokeWidth="2"
    />
    <path d="M20 32l8-8v6h36v4H28v6z" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

// Icona Menu - REALISTICA
export const MenuIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <path d="M8 16h48M8 32h48M8 48h48" stroke={color} strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

// Icona Grid - REALISTICA
export const GridIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="6" y="6" width="24" height="24" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <rect x="34" y="6" width="24" height="24" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <rect x="6" y="34" width="24" height="24" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
    <rect x="34" y="34" width="24" height="24" rx="2" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/>
  </svg>
);

// Icona List - REALISTICA
export const ListIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="8" y="8" width="8" height="8" rx="1" fill={color} fillOpacity="0.3"/>
    <rect x="8" y="20" width="8" height="8" rx="1" fill={color} fillOpacity="0.3"/>
    <rect x="8" y="32" width="8" height="8" rx="1" fill={color} fillOpacity="0.3"/>
    <rect x="8" y="44" width="8" height="8" rx="1" fill={color} fillOpacity="0.3"/>
    <path d="M28 12h28M28 24h28M28 36h28M28 48h28" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// Icona External Link - REALISTICA
export const ExternalLinkIcon = ({ className = "w-10 h-10", color = "currentColor" }: IconProps) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect x="8" y="8" width="32" height="32" rx="2" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M24 8V4h32v32h-4" stroke={color} strokeWidth="2" strokeLinejoin="round"/>
    <path d="M8 40l12-12 12 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// =============================================================================
// LUCIDE-STYLE ICONS (24x24, stroke-based, modern)
// =============================================================================

interface LucideIconProps {
  className?: string;
  size?: number;
}

// Icona Refresh/ArrowPath - Lucide Style
export const RefreshIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
    <path d="M3 3v5h5"/>
    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
    <path d="M16 16h5v5"/>
  </svg>
);

// Icona Image - Lucide Style
export const ImageLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
    <circle cx="8.5" cy="8.5" r="1.5"/>
    <polyline points="21 15 16 10 5 21"/>
  </svg>
);

// Icona ChevronUp - Lucide Style
export const ChevronUpIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="18 15 12 9 6 15"/>
  </svg>
);

// Icona ChevronDown - Lucide Style
export const ChevronDownIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

// Icona ChevronLeft - Lucide Style
export const ChevronLeftIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);

// Icona X/Close - Lucide Style
export const CloseIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

// Icona Plus (no circle) - Lucide Style
export const PlusLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"/>
    <line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

// Icona Minus (no circle) - Lucide Style
export const MinusLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

// Icona Filter - Lucide Style
export const FilterLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
  </svg>
);

// Icona Search - Lucide Style
export const SearchLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

// Icona MapPin - Lucide Style
export const MapPinLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

// Icona User - Lucide Style
export const UserLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

// Icona Phone - Lucide Style
export const PhoneLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

// Icona Mail - Lucide Style
export const MailLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

// Icona Heart - Lucide Style
export const HeartLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);

// Icona HeartFilled - Lucide Style
export const HeartFilledLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);

// Icona Tag/Label - Lucide Style
export const TagLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
    <path d="M7 7h.01" />
  </svg>
);

// Icona Sun - Lucide Style
export const SunLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </svg>
);

// Icona Radio - Lucide Style
export const RadioLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="12" cy="12" r="2" />
    <path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14" />
  </svg>
);

// Icona Armchair/Seat - Lucide Style
export const ArmchairLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3" />
    <path d="M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z" />
    <path d="M5 18v2" />
    <path d="M19 18v2" />
  </svg>
);

// Icona Star - Lucide Style
export const StarLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

// Icona StarFilled - Lucide Style
export const StarFilledLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

// Icona Share - Lucide Style
export const ShareLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3"/>
    <circle cx="6" cy="12" r="3"/>
    <circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);

// Icona Edit/Pencil - Lucide Style
export const EditLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

// Icona Trash - Lucide Style
export const TrashLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
  </svg>
);

// Icona Menu - Lucide Style
export const MenuLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="6" x2="21" y2="6"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

// Icona Grid - Lucide Style
export const GridLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7"/>
    <rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/>
    <rect x="3" y="14" width="7" height="7"/>
  </svg>
);

// Icona List - Lucide Style
export const ListLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="8" y1="6" x2="21" y2="6"/>
    <line x1="8" y1="12" x2="21" y2="12"/>
    <line x1="8" y1="18" x2="21" y2="18"/>
    <line x1="3" y1="6" x2="3.01" y2="6"/>
    <line x1="3" y1="12" x2="3.01" y2="12"/>
    <line x1="3" y1="18" x2="3.01" y2="18"/>
  </svg>
);

// Icona ArrowUp - Lucide Style
export const ArrowUpLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="12" y1="19" x2="12" y2="5"/>
    <polyline points="5 12 12 5 19 12"/>
  </svg>
);

// Icona ArrowDown - Lucide Style
export const ArrowDownLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"/>
    <polyline points="19 12 12 19 5 12"/>
  </svg>
);

// Icona ArrowLeft - Lucide Style
export const ArrowLeftLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="19" y1="12" x2="5" y2="12"/>
    <polyline points="12 19 5 12 12 5"/>
  </svg>
);

// Icona ArrowRight - Lucide Style
export const ArrowRightLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

// Icona Check - Lucide Style
export const CheckLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

// Icona Eye - Lucide Style
export const EyeLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

// Icona EyeOff - Lucide Style
export const EyeOffLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

// Icona Settings - Lucide Style
export const SettingsLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

// Icona Bell - Lucide Style
export const BellLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
  </svg>
);

// Icona Home - Lucide Style
export const HomeLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

// Icona LogIn - Lucide Style
export const LogInLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
    <polyline points="10 17 15 12 10 7"/>
    <line x1="15" y1="12" x2="3" y2="12"/>
  </svg>
);

// Icona LogOut - Lucide Style
export const LogOutLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

// Icona MessageSquare/Chat - Lucide Style
export const MessageSquareLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

// Icona MessageCircle/WhatsApp - Lucide Style
export const MessageCircleLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21"/>
    <path d="M9 10a.5.5 0 0 0 0 1"/>
    <path d="M12 10a.5.5 0 0 0 0 1"/>
    <path d="M15 10a.5.5 0 0 0 0 1"/>
    <path d="M7.5 13.5a5.5 5.5 0 0 0 9 0"/>
  </svg>
);

// Icona Upload - Lucide Style
export const UploadLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="17 8 12 3 7 8"/>
    <line x1="12" y1="3" x2="12" y2="15"/>
  </svg>
);

// Icona Download - Lucide Style
export const DownloadLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

// Icona File - Lucide Style
export const FileLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
    <polyline points="13 2 13 9 20 9"/>
  </svg>
);

// Icona Folder - Lucide Style
export const FolderLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
  </svg>
);

// Icona Clock - Lucide Style
export const ClockLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

// Icona Calendar - Lucide Style
export const CalendarLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

// Icona Building - Lucide Style
export const BuildingLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"/>
    <path d="M9 22v-4h6v4"/>
    <path d="M8 6h.01"/>
    <path d="M16 6h.01"/>
    <path d="M12 6h.01"/>
    <path d="M12 10h.01"/>
    <path d="M12 14h.01"/>
    <path d="M16 10h.01"/>
    <path d="M16 14h.01"/>
    <path d="M8 10h.01"/>
    <path d="M8 14h.01"/>
  </svg>
);

// Icona Map - Lucide Style
export const MapLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/>
    <line x1="8" y1="2" x2="8" y2="18"/>
    <line x1="16" y1="6" x2="16" y2="22"/>
  </svg>
);

// Icona Truck - Lucide Style
export const TruckLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="1" y="3" width="15" height="13"/>
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
    <circle cx="5.5" cy="18.5" r="2.5"/>
    <circle cx="18.5" cy="18.5" r="2.5"/>
  </svg>
);

// Icona Euro - Lucide Style
export const DollarSignLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M4 10h12"/>
    <path d="M4 14h9"/>
    <path d="M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12a7.9 7.9 0 0 0 7.8 8 7.7 7.7 0 0 0 5.2-2"/>
  </svg>
);

// Icona TrendingUp - Lucide Style
export const TrendingUpLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
    <polyline points="17 6 23 6 23 12"/>
  </svg>
);

// Icona TrendingDown - Lucide Style
export const TrendingDownLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/>
    <polyline points="17 18 23 18 23 12"/>
  </svg>
);

// Icona Users - Lucide Style
export const UsersLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

// Icona Package - Lucide Style
export const PackageLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
    <line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);

// Icona Anchor - Lucide Style
export const AnchorLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="5" r="3"/>
    <line x1="12" y1="22" x2="12" y2="8"/>
    <path d="M5 12H2a10 10 0 0 0 20 0h-3"/>
  </svg>
);

// Icona Zap - Lucide Style (for motors)
export const ZapLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);

// Icona Shield - Lucide Style
export const ShieldLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

// Icona BarChart - Lucide Style
export const BarChartLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="12" y1="20" x2="12" y2="10"/>
    <line x1="18" y1="20" x2="18" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="16"/>
  </svg>
);

// Icona Activity - Lucide Style
export const ActivityLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </svg>
);

// Icona Book - Lucide Style
export const BookLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </svg>
);

// Icona Database - Lucide Style
export const DatabaseLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <ellipse cx="12" cy="5" rx="9" ry="3"/>
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
  </svg>
);

// Icona PlusCircle - Lucide Style
export const PlusCircleLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="16"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
  </svg>
);

// Icona Info - Lucide Style
export const InfoLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="16" x2="12" y2="12"/>
    <line x1="12" y1="8" x2="12.01" y2="8"/>
  </svg>
);

// Icona AlertTriangle - Lucide Style
export const AlertTriangleLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

// Icona AlertCircle - Lucide Style
export const AlertCircleLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

// Icona CheckCircle - Lucide Style
export const CheckCircleLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

// Icona XCircle - Lucide Style
export const XCircleLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <line x1="15" y1="9" x2="9" y2="15"/>
    <line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
);

// Icona CreditCard - Lucide Style
export const CreditCardLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
    <line x1="1" y1="10" x2="23" y2="10"/>
  </svg>
);

// Icona Navigation - Lucide Style
export const NavigationLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="3 11 22 2 13 21 11 13 3 11"/>
  </svg>
);

// Icona Ruler - Lucide Style
export const RulerLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21.21 15.89A1 1 0 0 0 22 15V6a1 1 0 0 0-.29-.71l-4-4a1 1 0 0 0-1.42 0l-9 9-4 4a1 1 0 0 0 0 1.42l4 4A1 1 0 0 0 9 21v-6a1 1 0 0 0 .21-.89z"/>
    <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
  </svg>
);

// Icona ExternalLink - Lucide Style
export const ExternalLinkLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    <polyline points="15 3 21 3 21 9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

// Icona Fuel - Lucide Style
export const FuelLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M3 22V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"/>
    <path d="M3 22h12"/>
    <path d="M15 14h2a2 2 0 0 1 2 2v3a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2v-3a2 2 0 0 1 2-2h2"/>
    <path d="M12 6v8"/>
  </svg>
);

// Icona Gauge/Speedometer - Lucide Style
export const GaugeLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"/>
    <path d="M12 6v6l4 2"/>
  </svg>
);

// Icona Weight - Lucide Style
export const WeightLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M6.5 6.5h11v7.5h-11z"/>
    <path d="M6.5 13.5h11"/>
    <path d="M6.5 17.5h11"/>
    <path d="M3 20h18"/>
    <path d="M12 2v6"/>
  </svg>
);

// Icona ZoomIn - Lucide Style
export const ZoomInLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    <line x1="11" y1="8" x2="11" y2="14"/>
    <line x1="8" y1="11" x2="14" y2="11"/>
  </svg>
);

// Icona Play - Lucide Style
export const PlayLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polygon points="5 3 19 12 5 21 5 3"/>
  </svg>
);

// Icona Waves/Water - Lucide Style
export const WavesLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>
    <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>
    <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>
  </svg>
);

// Icona Battery - Lucide Style
export const BatteryLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="1" y="6" width="18" height="12" rx="2" ry="2"/>
    <line x1="23" y1="10" x2="23" y2="14"/>
    <line x1="6" y1="10" x2="6" y2="14"/>
    <line x1="10" y1="10" x2="10" y2="14"/>
    <line x1="14" y1="10" x2="14" y2="14"/>
  </svg>
);

// Icona Tv - Lucide Style
export const TvLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="2" y="7" width="20" height="15" rx="2" ry="2"/>
    <polyline points="17 2 12 7 7 2"/>
  </svg>
);

// Icona Compass - Lucide Style
export const CompassLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>
  </svg>
);

// Icona History - Lucide Style
export const HistoryLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M3 3v5h5"/>
    <path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/>
    <path d="M12 7v5l4 2"/>
  </svg>
);

// Icona ChevronRight - Lucide Style
export const ChevronRightLucideIcon = ({ className = "w-5 h-5", size = 24 }: LucideIconProps) => (
  <svg 
    className={className} 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

// ============================================
// TIPOLOGIE IMBARCAZIONI - Badge System
// ============================================

// Icona Gommone - stile Lucide
export const GommoneIcon = ({
  className = "w-8 h-8",
  color = "#3B82F6",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="32"
      cy="36"
      rx="24"
      ry="12"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path
      d="M8 36C8 28 20 20 32 20C44 20 56 28 56 36"
      stroke={color}
      strokeWidth="2"
    />
    <ellipse cx="32" cy="36" rx="24" ry="12" stroke={color} strokeWidth="2" />
    <circle cx="16" cy="32" r="4" fill={color} fillOpacity="0.3" />
    <circle cx="48" cy="32" r="4" fill={color} fillOpacity="0.3" />
  </svg>
);

// Icona RIB
export const RibIcon = ({
  className = "w-8 h-8",
  color = "#06B6D4",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 28L20 44H44L56 28V20L32 8L8 20V28Z"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M8 28L32 44L56 28" stroke={color} strokeWidth="2" />
    <path d="M20 44L32 34L44 44" stroke={color} strokeWidth="2" />
    <ellipse cx="32" cy="26" rx="18" ry="4" stroke={color} strokeWidth="2" />
  </svg>
);

// Icona Tender
export const TenderIcon = ({
  className = "w-8 h-8",
  color = "#F59E0B",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 24L32 40L48 24H16Z"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M32 40V52" stroke={color} strokeWidth="2" />
    <circle cx="32" cy="52" r="3" fill={color} />
    <path d="M24 20H40" stroke={color} strokeWidth="2" />
  </svg>
);

// Icona Open/Daycruiser
export const OpenIcon = ({
  className = "w-8 h-8",
  color = "#10B981",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 32L24 44H40L56 32V24L32 16L8 24V32Z"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M24 44H40" stroke={color} strokeWidth="2" />
    <path d="M16 28H48" stroke={color} strokeWidth="2" strokeDasharray="4 2" />
    <path d="M32 16V28" stroke={color} strokeWidth="2" />
  </svg>
);

// Icona Center Console / Fishing
export const FishingIcon = ({
  className = "w-8 h-8",
  color = "#EF4444",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 28L20 44H44L56 28V20L32 8L8 20V28Z"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <rect
      x="24"
      y="16"
      width="16"
      height="10"
      rx="2"
      fill={color}
      fillOpacity="0.3"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M32 26V38" stroke={color} strokeWidth="2" />
    <circle cx="32" cy="42" r="2" fill={color} />
    <path d="M40 14L44 8L48 14" stroke={color} strokeWidth="2" />
  </svg>
);

// Icona Flybridge
export const FlybridgeIcon = ({
  className = "w-8 h-8",
  color = "#6366F1",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 36L24 48H40L56 36V28L32 16L8 28V36Z"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M16 48H48" stroke={color} strokeWidth="2" />
    <rect
      x="20"
      y="28"
      width="24"
      height="8"
      rx="1"
      fill={color}
      fillOpacity="0.3"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M24 16H40" stroke={color} strokeWidth="2" />
  </svg>
);

// Icona Sport
export const SportIcon = ({
  className = "w-8 h-8",
  color = "#F97316",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 32C8 24 20 16 32 16C44 16 56 24 56 32C56 40 44 48 32 48C20 48 8 40 8 32Z"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M20 28L32 40L44 28" stroke={color} strokeWidth="2" />
    <circle cx="32" cy="32" r="6" stroke={color} strokeWidth="2" />
  </svg>
);

// Icona Catamarano
export const CatamaranIcon = ({
  className = "w-8 h-8",
  color = "#EC4899",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 36L16 44H48L60 36" stroke={color} strokeWidth="2" />
    <path d="M16 44V52H48V44" stroke={color} strokeWidth="2" />
    <path d="M20 36V24L32 16L44 24V36" stroke={color} strokeWidth="2" />
    <path d="M4 36V28L32 12L60 28V36" stroke={color} strokeWidth="2" />
  </svg>
);

// Icona Vela
export const VelaIcon = ({
  className = "w-8 h-8",
  color = "#0EA5E9",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 52V16L48 40V16"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M16 52H52" stroke={color} strokeWidth="2" />
    <path d="M20 52V20L44 40V20" stroke={color} strokeWidth="2" />
    <circle cx="16" cy="52" r="3" fill={color} />
  </svg>
);

// Icona Yacht/Motoryacht
export const YachtIcon = ({
  className = "w-8 h-8",
  color = "#EAB308",
}: IconProps) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 40L20 52H44L56 40V28L32 12L8 28V40Z"
      fill={color}
      fillOpacity="0.2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M16 52H48" stroke={color} strokeWidth="2" />
    <rect
      x="22"
      y="32"
      width="20"
      height="8"
      rx="1"
      fill={color}
      fillOpacity="0.3"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M28 12V28" stroke={color} strokeWidth="2" />
    <path d="M40 12V28" stroke={color} strokeWidth="2" />
  </svg>
);
